export default __webpack_public_path__ + "static/media/homeback.7a0abcaa.png";